import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogEditMaintenanceComponent } from './dialog-maintenances.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "../../../../core/api/maintenances/maintenances.api";
import * as i3 from "../../../../core/authentication/authentication.service";
import * as i4 from "../../../../../@fuse/components/progress-bar/progress-bar.service";
var DialogMaintenancesService = /** @class */ (function () {
    function DialogMaintenancesService(matDialog, maintenancesApi, authenticationService, fuseProgressBarService) {
        this.matDialog = matDialog;
        this.maintenancesApi = maintenancesApi;
        this.authenticationService = authenticationService;
        this.fuseProgressBarService = fuseProgressBarService;
    }
    DialogMaintenancesService.prototype.open = function (maintenanceId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMaintenance(maintenanceId)];
                    case 1:
                        maintenance = _a.sent();
                        return [2 /*return*/, this.matDialog.open(DialogEditMaintenanceComponent, {
                                panelClass: 'dialog-edit-maintenance',
                                autoFocus: false,
                                data: {
                                    maintenance: maintenance,
                                    isViewMode: !this.authenticationService.hasPermission('maintenances-edit'),
                                }
                            }).afterClosed()
                                .toPromise()];
                }
            });
        });
    };
    DialogMaintenancesService.prototype.getMaintenance = function (maintenanceId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.maintenancesApi.searchOne(maintenanceId).toPromise()];
                    case 1:
                        result = _a.sent();
                        this.fuseProgressBarService.hide();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    DialogMaintenancesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DialogMaintenancesService_Factory() { return new DialogMaintenancesService(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(i2.MaintenancesApi), i0.ɵɵinject(i3.AuthenticationService), i0.ɵɵinject(i4.FuseProgressBarService)); }, token: DialogMaintenancesService, providedIn: "root" });
    return DialogMaintenancesService;
}());
export { DialogMaintenancesService };
